export enum CustomerDocumentType {
  PASSPORT = "Passport",
  DRIVER_LICENSE = "Driver license",
  BANK_APPROVAL = "Bank approval",
}
